import { useSelector } from "react-redux";
import { getUserIdFromState } from "../mappers/backendMappers";

/**
 * The current portal user id from Redux, or the anonymous (all-zero) id when
 * nobody is logged in. Use this instead of hardcoding the anonymous id so the
 * backend applies the logged-in user's role/organization visibility rules.
 */
const useUserId = () => useSelector(getUserIdFromState);

export default useUserId;
